import { render, staticRenderFns } from "./DetailProduk.vue?vue&type=template&id=ad1391cc&scoped=true"
import script from "./DetailProduk.vue?vue&type=script&lang=js"
export * from "./DetailProduk.vue?vue&type=script&lang=js"
import style0 from "./DetailProduk.vue?vue&type=style&index=0&id=ad1391cc&prod&lang=scss&scoped=true"
import style1 from "./DetailProduk.vue?vue&type=style&index=1&id=ad1391cc&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ad1391cc",
  null
  
)

export default component.exports